import type { TOC } from '@ember/component/template-only';
import HotelAndMarketNavigationTabsTabMainNavigation from 'lumen/components/hotel-and-market/navigation/tabs/tab-main-navigation';

import styles from './navigation-main-tabs.module.css';

interface HotelAndMarketNavigationNavigationMainTabsSignature {
  Args: {
    menuItems: unknown;
  };
}

const HotelAndMarketNavigationNavigationMainTabs = <template>
  <ul class={{styles.tabs-list}}>
    {{! @glint-expect-error: Incorrect type }}
    {{#each @menuItems as |group|}}
      {{#each group.children as |item|}}
        <HotelAndMarketNavigationTabsTabMainNavigation @item={{item}} />
      {{/each}}
    {{/each}}
  </ul>
</template> satisfies TOC<HotelAndMarketNavigationNavigationMainTabsSignature>;

export default HotelAndMarketNavigationNavigationMainTabs;
